import { render, staticRenderFns } from "./ProductOptionGroup.vue?vue&type=template&id=3ff82b7c"
import script from "./ProductOptionGroup.vue?vue&type=script&lang=js"
export * from "./ProductOptionGroup.vue?vue&type=script&lang=js"
import style0 from "./ProductOptionGroup.vue?vue&type=style&index=0&id=3ff82b7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports